import { useRef, useState } from "react";
import styles from "./QuickAddForm.module.css";
import { SymbolButton, SymbolButtonMode } from "../../../components/manage/SymbolButton";

interface Props {
  ean: string;
  quantity: string;
  onEanChange: (val: string) => void;
  onQuantityChange: (val: string) => void;
  onAdd: () => void;
  isOverwriteQuantities: boolean;
  quantityInputRef?: React.RefObject<HTMLInputElement>;
}

export const QuickAddForm = ({
  ean,
  quantity,
  onEanChange,
  onQuantityChange,
  onAdd,
  isOverwriteQuantities,
  quantityInputRef
}: Props) => {
  const eanRef = useRef<HTMLInputElement>(null);
  const localQtyRef = useRef<HTMLInputElement>(null);

  const qtyRef = quantityInputRef || localQtyRef;

  const handleSubmit = () => {
    onAdd();
    eanRef.current?.focus();
  };

  const isManual = localStorage.getItem("manual_input") === "true";

  // const [symbolButtonMode, setSymbolButtonMode] = useState<SymbolButtonMode>(SymbolButtonMode.EQUALS);

  // const nextSymbolButtonMode = () => {
  //   setSymbolButtonMode((prevMode) => {
  //     switch (prevMode) {
  //       case SymbolButtonMode.EQUALS:
  //         return SymbolButtonMode.ADD;
  //       case SymbolButtonMode.ADD:
  //         return SymbolButtonMode.SUBTRACT;
  //       case SymbolButtonMode.SUBTRACT:
  //         return SymbolButtonMode.EQUALS;
  //       default:
  //         return SymbolButtonMode.EQUALS;
  //     }
  //   });
  // };

  return (
    <div className={styles.formContainer}>
      <div className={styles.inputRow}>
        <input
          ref={eanRef}
          value={ean}
          onChange={(e) => onEanChange(e.target.value)}
          placeholder={isManual ? "Wpisz kod EAN" : "Skanuj EAN"}
          maxLength={13}
          inputMode={isManual ? "decimal" : "none"}
          onKeyDown={(e) => e.key === "Enter" && qtyRef.current?.focus()}
          required
        />
        {/* <SymbolButton mode={symbolButtonMode} onClick={() => nextSymbolButtonMode()} /> */}
        <input
          ref={qtyRef}
          value={quantity}
          onChange={(e) => onQuantityChange(e.target.value)}
          placeholder="Ilość"
          inputMode="decimal"
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          maxLength={4}
        />
        {/*
        DODAC TRZY TRYBY
        PRZYKLAD WYSWIETLANIA: 6758475833845 X 49 [PRZYCISK-ZNAK] 65 [PRZYCISK-ZATWIERDZ]
        [PRZYCISK-ZNAK]:
        [-] ODEJMOWANIE
        [+] DODAWANIE
        [=] PRZYPISANIE
        */}
      </div>
      {/* <button className={styles.saveButton} onClick={handleSubmit}>{isOverwriteQuantities ? "NADPISZ" : "DODAJ"}</button> */}
      <button onClick={handleSubmit}>{isOverwriteQuantities ? "NADPISZ" : "DODAJ"}</button>
    </div>
  );
};
